module.exports = "/_next/static/resources/life2-17aff3a524b191004aa2ab8561942ef4.jpg";